import React, { useRef, useState, useEffect } from 'react';

export default function Dialog(props)
{

  const docHeight = document.body.clientHeight;

  const componentRef = useRef(null);

  const { height } = useDimensions(componentRef);

    //style={{ marginTop: 110 + offset + 'px'}}

  return (
    <div className="dialog-container" style={{height: docHeight+'px'}} >
          <div className="dialog-content" id="dialog-content" >
        <div className="container ">
        <div className="row mb-2" ref={componentRef} >
            <div className="d-flex align-items-end col-10 col-md-11">
              <h4>{props.title}</h4>
            </div>
            <div className="text-right col-2 col-md-1 p-sm-0">
              <i className="mt-3 fas fa-window-close" onClick={props.onClose}></i>
            </div>
          </div>
          <div className="row pb-5">
            <div className="col-12 dialog-inner-content" style={{  height: height + 'px' }}>
              
              {props.children}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

const MobileHeightAdj = 200;
const DefaultHeightAdj = 280;

export const useDimensions = myRef => {
  const getDimensions = () => {

        let mobile = (window.innerWidth <= 760);

        let height = myRef.current ? window.innerHeight - myRef.current.offsetTop - (mobile ? MobileHeightAdj : DefaultHeightAdj) : 0;

        return ({
          height,
          mobile
        });
  };

  const [dimensions, setDimensions] = useState({ height: 0});

  useEffect(() => {
      const handleResize = () => {
        setDimensions(getDimensions());
      }

      if (myRef.current) {
        setDimensions(getDimensions());
      }

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      }
    },
    [myRef]);

  return dimensions;
};




export const useContainerDimensions = myRef => {
  const getDimensions = () => ({
    width: myRef.current ? myRef.current.offsetWidth : 0,
    height: myRef.current ? myRef.current.offsetHeight : 0
    
  });

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
      const handleResize = () => {
        setDimensions(getDimensions());
      }

      if (myRef.current) {
        setDimensions(getDimensions());
      }

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      }
    },
    [myRef]);

  return dimensions;
};
